import { render, staticRenderFns } from "./AuthComponent.vue?vue&type=template&id=22cb6f1e&scoped=true"
import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb6f1e",
  null
  
)

export default component.exports